<template>
    <simple-dropdown
        button-class="inline-flex items-center px-1.5 border border-transparent font-medium outline-none text-indigo-600 hover:text-indigo-800 transition duration-300">>
        <div slot="labelHeader" class="flex items-center font-medium text-indigo-600 hover:text-indigo-700 transition duration-300">
            <icon-pencil-box-multiple-filled class="w-4 h-4 mr-2 text-indigo-600"></icon-pencil-box-multiple-filled>
            <span>Bulk Update Selected Issues</span>
        </div>

        <template slot="buttonOptions">
            <simple-dropdown-option v-for="(requiredAction, index) in actionTypes"
                                    :value="requiredAction"
                                    :key="requiredAction + index"
                                    @click="selectRequiredAction(requiredAction)">
                {{ requiredAction }}
            </simple-dropdown-option>
        </template>
    </simple-dropdown>
</template>

<script>
export default {
    name: "BulkUpdateIssuesDropdown",

    props: {
        actionTypes: {
            required: true,
            type: Array,
            Description: "Used for the simple dropdown"
        }
    },

    methods: {
        selectRequiredAction (requiredAction) {
            this.$emit("action-selected", requiredAction);
        },
    },
};
</script>